<template>
    <div>
			<b-table-simple responsive bordered  style="width: 100%;">
				<b-thead>
						<b-tr v-if="import_status != 'NEW'">
							<b-th rowspan="2">No.</b-th>
							<b-th class="text-center bg-warning" colspan="5" v-if="import_status == 'DUPLICATE'">Existing Data</b-th>
							<b-th class="text-center bg-warning" colspan="4" v-if="import_status == 'UPDATE'">Existing Data</b-th>
							<b-th class="text-center bg-info" colspan="7">New Import Data</b-th>
						</b-tr>
						<b-tr>
							<b-th v-if="import_status == 'NEW'">No.</b-th>
							<b-th v-if="import_status != 'NEW'">Lead Id</b-th>
							<b-th v-if="import_status == 'DUPLICATE'">Has Assigned To</b-th>
							<b-th v-if="import_status != 'NEW'">Current Channel</b-th>
							<b-th>Name</b-th>
							<b-th>Contact No</b-th>
							<b-th>Channel</b-th>
							<b-th>Platform</b-th>
							<b-th>Type</b-th>
							<b-th>Income</b-th>
							<!-- <b-th>Status</b-th> -->
							<b-th>Email</b-th>
							<!-- <b-th>Assign To</b-th> -->
						</b-tr>
				</b-thead>
				<b-tbody v-if="!_gHlp.isEmpty(tableData)">
						<b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
								<b-td>{{ index + 1 }}</b-td>
								<b-td v-if="import_status != 'NEW'">{{ item.lead_id }}</b-td>
								<b-td class="text-left" v-if="import_status == 'DUPLICATE'">
									 {{ hasAssignedTo(item) }}
								</b-td>
								<b-td class="text-left" v-if="import_status != 'NEW'">
									 {{ item.current_channel }}
								</b-td>
								<b-td class="text-left">{{ item.name }}</b-td>
								<b-td class="text-left">{{ item.contact_no }}</b-td>
								<b-td class="text-left">{{ item.channel }}</b-td>
								<b-td class="text-left">{{ item.platform }}</b-td>
								<b-td>{{ item.type }}</b-td>
								<b-td>{{ item.income }}</b-td>
								<!-- <b-td>{{ item.status }}</b-td> -->
								<b-td class="text-left">{{ item.email }}</b-td>
								<!-- <b-td>{{ item.assign_to }}</b-td> -->
						</b-tr>
				</b-tbody>
				<b-tbody v-else>
						<b-tr>
								<b-td colspan="11"><i>No Record</i></b-td>
						</b-tr>
				</b-tbody>
			</b-table-simple>
    </div>
</template>

<script>
    export default {
        name: 'import-summary-content',
        props: ['tableData','import_status'],
        components: {
        },
        data() {
					return {
							
					}
        },
				methods: {
            hasAssignedTo(item){
							if(_gHlp.isEmpty(item.has_assigned_to)) return '-';
							let namesList = Object.values(item.has_assigned_to).map(item => item.name);
							return namesList.join(", ");
						}
        },
    }
</script>